import { ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { HighlightBadge } from '../../Badge';
import { BonusesPanel } from '../BonusesPanel';
import { useSearchContext } from '../context';
import { RecordsPanel } from '../RecordsPanel';
import { UsersPanel } from '../UsersPanel';

export interface SearchTab {
	key: string;
	label: ReactNode;
	content: ReactNode;
	analyticsKey: string;
}

export const useSearchTabs = (): SearchTab[] => {
	const { bonusCount, hasAllRecords, hasBonuses, hasUsers, recordCount, userCount } = useSearchContext();

	const { t } = useTranslation('navigation');

	return useMemo(
		() =>
			[
				hasAllRecords && {
					key: 'all',
					label: (
						<>
							{t('search.all_tab')} <HighlightBadge ml={1}>{recordCount}</HighlightBadge>
						</>
					),
					content: <RecordsPanel />,
					analyticsKey: 'All',
				},
				hasUsers && {
					key: 'users',
					label: (
						<>
							{t('search.users_tab')} <HighlightBadge ml={1}>{userCount}</HighlightBadge>
						</>
					),
					content: <UsersPanel />,
					analyticsKey: 'Users',
				},
				hasBonuses && {
					key: 'bonuses',
					label: (
						<>
							{t('search.recognition_tab')} <HighlightBadge ml={1}>{bonusCount}</HighlightBadge>
						</>
					),
					content: <BonusesPanel />,
					analyticsKey: 'Recognitions',
				},
			].filter(Boolean) as SearchTab[],
		[bonusCount, hasAllRecords, hasBonuses, hasUsers, recordCount, t, userCount]
	);
};
